import { Big } from "big.js"

export const ETH_DECIMAL_DIGITS = 18
export const ERC20_DECIMAL_DIGITS = 18
export const COLLATERAL_TOKEN_DECIMAL = 6
export const SETTLEMENT_TOKEN_DECIMAL = 6
export const RATIO_DECIMAL = 6

export const Q96 = new Big(2).pow(96)
export const BIG_ZERO = new Big(0)
export const BIG_ONE = new Big(1)
